import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import Highlight from './Highlight';

interface Props {
  inputValue: string;
}

const EmptySearch: React.FC<Props> = ({ inputValue }) => {
  return (
    <EmptyResults>
      <EmptyResultsText className="mb-3">
        <Trans
          i18nKey="No results for: <highlight />"
          defaults="No results for: <highlight />"
          components={{
            highlight: <Highlight text={inputValue} />,
          }}
        />
      </EmptyResultsText>
      <EmptyResultsText>
        <Trans
          i18nKey="Please refine your search term and select a reason for your visit."
          defaults="Please refine your search term and select a reason for your visit."
        />
      </EmptyResultsText>
    </EmptyResults>
  );
};

export default EmptySearch;

const EmptyResults = styled.div`
  font-weight: var(--weight-regular);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;

const EmptyResultsText = styled.div`
  color: var(--color-shade-70);
  width: 100%;
  font-size: 0.875rem;
`;
